import { GetAllM24OpenFiltersDTO, GetAllM24OpenResponseData } from "./dto";
import { MonitoringM24OpenImpl } from "./serviceImpl";

export interface MonitoringM24OpenService {
    GetAllM24Open(filters: GetAllM24OpenFiltersDTO): Promise<GetAllM24OpenResponseData[]>
}

export function NewMonitoringM24OpenService(): MonitoringM24OpenService {
    return new MonitoringM24OpenImpl()
}